import React, { useState, FormEvent } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { BrandProps } from '../api/Brands';

export const BrandsItem = ({
  data,
  onCreateBrand,
  error,
}: {
  data?: BrandProps;
  onCreateBrand?: (props: BrandProps) => Promise<void>;
  error?: string;
}) => {
  const [name, setName] = useState(data?.name || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!name.trim() || !onCreateBrand) return;

    setIsSubmitting(true);
    try {
      await onCreateBrand({ name: name.trim() });
      setName('');
    } catch (err: any) {
      // Ошибка уже обработана в useBrands
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Row style={{ marginBottom: 16, padding: 16, border: '1px solid #ddd' }}>
      <Col>
        <Form>
          <Form.Group>
            <Form.Label>Название бренда</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Введите название бренда"
              disabled={isSubmitting}
            />
            {error && (
              <Form.Text className="text-danger" style={{ display: 'block' }}>
                {error}
              </Form.Text>
            )}
          </Form.Group>
          <Button
            type="submit"
            onClick={handleSubmit}
            disabled={!name.trim() || isSubmitting}
            style={{ marginTop: 8 }}
          >
            {isSubmitting ? 'Создание...' : 'Создать бренд'}
          </Button>
        </Form>
      </Col>
    </Row>
  );
};
